module.exports = __webpack_public_path__ + "img/topimg.21691d5b.png";